import React, { useEffect, useState } from "react";
import { AutoComplete, Spin, Space } from "antd";
import debounce from "lodash/debounce";
import { searchableSelectCheck } from "./searchable-select-check";

const SearchableSelectInput = ({
  valueSpec,
  onChange,
  onError,
  multiSelect = false,
  fetchValueSpec,
}) => {
  const [open, setOpen] = useState(false);
  const [specData, setSpecData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState("");
  const [selectedValue, setSelectedValue] = useState(multiSelect ? [] : "");
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setSelectedValue(valueSpec.value);
    setSpecData(valueSpec);
    refreshValueSpec();
    const err = checkValue(valueSpec.value, valueSpec);
    if (err) {
      setError(true);
      onError(true);
    }
    return () => {};
  }, [valueSpec]);

  const handleInputChange = (value) => {
    setInputText(value);
    if (fetchValueSpec) {
      const df = debounce(() => {
        refreshValueSpec();
      }, 1000);
      df();
    }
  };

  const refreshValueSpec = () => {
    if (fetchValueSpec) {
      fetchValueSpec(inputText)
        .then(vs => {
          const input = vs.value;
          if (input === inputText) {
            setSpecData(vs.valueSpec);
            setLoading(false);
          }
        })
        .catch(error => {
          console.error("Error fetching options:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const handleSelectChange = (value) => {
    const err = checkValue(value, specData);
    setSelectedValue(value);
    setError(err);
    onChange(value);
    onError(err);
  };

  const handleBlur = () => {
    // checkValue(inputText, specData);
  };

  const checkValue = (value, spec) => {
    if (multiSelect) {
      for (let i = 0; i < value.length; i++) {
        const err = !searchableSelectCheck(value[i], spec);
        if (err) {
          return err;
        }
      }
      return false;
    } else {
      const err = !searchableSelectCheck(value, spec);
      return err;
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        {valueSpec.name && (
          <h6 style={{ margin: 0, fontSize: "1rem", fontWeight: 600 }}>
            {valueSpec.name}
          </h6>
        )}
        <div style={{ width: "100%" }}>
          <AutoComplete
            mode={multiSelect ? "multiple" : undefined}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            options={specData ? (specData.enums || []).map(option => ({
              value: option,
              label: option,
            })) : []}
            loading={loading}
            value={selectedValue}
            onSearch={handleInputChange}
            onChange={handleSelectChange}
            onBlur={handleBlur}
            placeholder="Select value"
            status={error ? "error" : undefined}
            notFoundContent={loading ? <Spin size="small" /> : null}
          />
        </div>
      </Space>
    </div>
  );
};

export default SearchableSelectInput;
